import { searchApi } from './config/delfarApi';
import { SearchProductResponseDto } from './dto/search.dto';

export const searchProducts = async (query?: string): Promise<SearchProductResponseDto> =>
    searchApi.get<SearchProductResponseDto>('products', { params: { query } }).then((r) => r.data);
